import { GetterTree } from 'vuex';
import { StoreType } from '@/types/store/store.type';
import { StayStoreType } from '@/types/store/stay-store.type';

export const getters: GetterTree<StayStoreType, StoreType> = {
  getStays(state) {
    return state.stays;
  },
};
